import { ChevronLeft, ChevronRight } from "lucide-react";
import type { FC } from "react";

import { useHistoryNav } from "@/features/navigation/useHistoryNav";

import { HeaderIconButton } from "./AppHeaderShell";

export type HistoryNavProps = {
  /**
   * Where Back goes when the session has no in-app history (deep link, new
   * tab): the page's logical parent. Omit for pages without one.
   */
  fallbackBackTo?: string | null;
};

/**
 * Back / Forward chevrons that mirror the browser's history, so they always
 * agree with the browser's own buttons, and step up to the parent page when
 * there is nothing to go back to.
 */
export const HistoryNav: FC<HistoryNavProps> = ({ fallbackBackTo }) => {
  const nav = useHistoryNav({ fallbackBackTo });

  return (
    <>
      <HeaderIconButton
        label={nav.backLabel}
        disabled={!nav.canGoBack}
        onClick={nav.goBack}
      >
        <ChevronLeft className="size-4" />
      </HeaderIconButton>
      <HeaderIconButton
        label={nav.forwardLabel}
        disabled={!nav.canGoForward}
        onClick={nav.goForward}
      >
        <ChevronRight className="size-4" />
      </HeaderIconButton>
    </>
  );
};
